import React from 'react'
import { connect } from 'react-redux'
import { LineupCreateEditForm } from 'containers'
import { lineups as lineupsModule } from 'redux/modules'
import { createSubUrl } from 'utils/urlConstructor'
import PropTypes from 'prop-types'
import { LINEUPS_DASHBOARD_ROUTE } from 'constants/routes'

const LineupCreate = ({ history, match, createLineup }) => {
  const onSubmit = (values) => {
    createLineup(values).then(() =>
      history.push(createSubUrl(match, LINEUPS_DASHBOARD_ROUTE))
    )
  }

  return (
    <LineupCreateEditForm
      form="createLineup"
      caption="Create Lineup"
      onSubmit={onSubmit}
    />
  )
}

LineupCreate.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  createLineup: PropTypes.func.isRequired,
}

export default connect(null, {
  createLineup: lineupsModule.createLineup,
})(LineupCreate)
